/**
 * Represents a running total object used on adding a customer delivery
 * or grouping orders for a truck
 */
export class RunningTotal {

    public units    : number = 0;
    public weight   : number = 0;
    public singles  : number = 0;
    public sections : number = 0;
    public track    : number = 0;
    public hardware : number = 0;
    public feet     : number = 0;

    private UNIT_WARNING        = 999999;
    private WEIGHT_WARNING      = 999999;
    private SINGLE_WARNING      = 999999;
    private SECTION_WARNING     = 999999;
    private TRACK_WARNING       = 999999;
    private HARDWARE_WARNING    = 999999;

    public getUnitWarning = () => this.units > this.UNIT_WARNING ? 'unit-warning' : '';
    public getWeightWarning = () => this.weight > this.WEIGHT_WARNING ? 'weight-warning' : '';
    public getSingleWarning = () => this.singles > this.SINGLE_WARNING ? 'single-warning' : '';
    public getSectionWarning = () => this.sections > this.SECTION_WARNING ? 'section-warning' : '';
    public getTrackWarning = () => this.track > this.TRACK_WARNING ? 'track-warning' : '';
    public getHardwarWarning = () => this.hardware > this.HARDWARE_WARNING ? 'hardware-warning' : '';

}
